export default __webpack_public_path__ + "static/img2-33f212807409379bc8d51c6af166b32e.png";